import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg' | 'xl';
  isLoading?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'default',
  isLoading = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-teal-600 text-white hover:bg-teal-700 focus:ring-teal-500 shadow-md hover:shadow-lg',
    secondary: 'bg-stone-100 text-stone-900 hover:bg-stone-200 focus:ring-stone-500',
    outline: 'border-2 border-teal-600 text-teal-700 hover:bg-teal-50 focus:ring-teal-500'
  };
  const sizes = {
    default: 'h-12 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl w-full sm:w-auto' // Extra large for main CTAs
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-1">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-2" />}
      {children}
    </button>;
}